import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { userDashboardLinks } from '../../routes/navConfig.jsx';
import { filterLinksByRole } from '../../utils/rbacUtils.js';
import { useNavTree } from '../../shell/sidebar/NavTreeContext.js';

/**
 * The nav tree the page-header section-switcher dropdown walks: the one the sidebar shows for the current view
 * (hub, admin, a game, its onboarding steps, a portfolio...), so the dropdown offers the same pages as the nav.
 * It used to walk the static hub tree, which has no game pages: inside a game every page fell through to the
 * hub's "Games" row and the dropdown listed Homepage / Components / Games / Portfolio.
 *
 * The view's tree is already filtered to what this user can reach. Outside a dashboard shell (no NavTreeContext)
 * it falls back to the hub tree under the SAME gate as the sidebar (filterLinksByRole over role + effective
 * permissions), so restricted pages (e.g. RBAC Management) stay out of the dropdown. Items without a pagePath
 * aren't permission-gated (only role-gated); until permissions load, gated entries are hidden.
 */
export const useMenuNavTree = () => {
    const viewTree = useNavTree();
    const userRole = useSelector(state => state.dashboardContext.userRole);
    const effectivePermissions = useSelector(state => state.effectivePermissions);
    return useMemo(
        () => viewTree || filterLinksByRole(userDashboardLinks, userRole, effectivePermissions),
        [viewTree, userRole, effectivePermissions]
    );
};

export default useMenuNavTree;
